// extracted by mini-css-extract-plugin
module.exports = {"checkboxInput":"CheckboxDone_checkboxInput__3RpME","checkboxLabel":"CheckboxDone_checkboxLabel__3r0aR"};